















































import { Component, Vue } from 'vue-property-decorator'
import 'echarts/theme/macarons.js' // Theme used in BarChart, LineChart, PieChart and RadarChart
import BarChart from './components/BarChart.vue'
import StaticNetworkInstancesTable from './components/StaticNetworkInstancesTable.vue'
import DifficultyTimeCorrChart from './components/DifficultyTimeCorrChart.vue'
import TotalMachineHoursTimeSeries from './components/TotalMachineHoursTimeSeries.vue'
import PieChart from './components/PieChart.vue'
import RadarChart from './components/RadarChart.vue'
import PanelGroup from './components/PanelGroup.vue'
import Panel from "@/components/Panel/index.vue";

@Component({
  name: 'AdminDashboard',
  components: {
    StaticNetworkInstancesTable,
    DifficultyTimeCorrChart,
    TotalMachineHoursTimeSeries,
    Panel,
    BarChart,
    PieChart,
    RadarChart,
    PanelGroup, }
})
export default class extends Vue {

}
